<template>
  <div class="req-status">
    <p v-if="!data || data.length < 1" class="no_data">{{ $lange == "en" ? "No Data" : "暂无数据" }}</p>
    <e-charts
      v-else
      style="width: 100%"
      :options="options"
      auto-resize
    ></e-charts>
  </div>
</template>

<script>
// 请求数据-按状态

import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
// import "echarts/lib/component/legend";
import theme from "./theme";

export default {
  name: "RequestStatusBar",
  components: { ECharts },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      constants: {
        processed: this.$lange == "en" ? "Processing" : "处理中",
        observation: this.$lange == "en" ? "Monitoring" : "观察中",
        finish: this.$lange == "en" ? "Completed" : "已完成",
        close: this.$lange == "en" ? "Closed" : "已关闭",
        cancel: this.$lange == "en" ? "Cancel" : "已取消",
      },
    };
  },
  computed: {
    options() {
      // const seriesData = this.data.map((item) => ({
      //   name: this.constants[item.code],
      //   value: item.value,
      // }));
      const seriesData = Object.keys(this.constants).map((i) => {
        const data = this.data.find((d) => d.code == i);
        if (!data)
          return {
            name: this.constants[i],
            value: null,
          };
        return {
          name: this.constants[i],
          value: data.value,
        };
      });
      return {
        ...theme,
        // tooltip: {
        //   trigger: "axis",
        //   axisPointer: {
        //     type: "shadow",
        //   },
        // },
        xAxis: {
          type: "category",
          data: Object.values(this.constants),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "状态",
            type: "bar",
            data: seriesData,
            label: {
              show: true,
              position: "top",
              formatter: (params) => (params.value ? params.value : ""),
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.no_data {
  text-align: center;
  color: #86898f;
  /* align-self: center; */
  transform: translateY(-50%);
  position: relative;
  top: 50%;
  left: 0;
}
</style>
